import { render, staticRenderFns } from "./ChartPieV2.vue?vue&type=template&id=659ee9f7&scoped=true"
import script from "./ChartPieV2.vue?vue&type=script&lang=js"
export * from "./ChartPieV2.vue?vue&type=script&lang=js"
import style0 from "./ChartPieV2.vue?vue&type=style&index=0&id=659ee9f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659ee9f7",
  null
  
)

export default component.exports